<template>
    <div class="min-h-screen bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <img class="mx-auto h-20 w-auto" src="/img/logo.png" alt="Workflow">
            <h2 class="mt-6 text-center text-3xl font-extrabold text-yellow-400">
                Sign in to your account
            </h2>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md border-t-4 border-dashed border-gray-600">
            <div class="py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form class="space-y-6" method="POST" @submit.prevent="submit">
                    <div>
                        <label for="username" class="block text-sm font-medium text-gray-100">
                            Username
                        </label>
                        <div class="mt-1">
                            <text-input id="username" v-model="form.username" :error="errors.username" type="text" required />
                        </div>
                    </div>

                    <div>
                        <label for="password" class="block text-sm font-medium text-gray-100">
                            Password
                        </label>
                        <div class="mt-1">
                            <text-input v-model="form.password" id="password" type="password" required />
                        </div>
                    </div>

                    <div class="flex items-center justify-between hidden">
                        <div class="flex items-center">
                            <input v-model="form.remember" id="remember_me" type="checkbox" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                            <label for="remember_me" class="ml-2 block text-sm text-gray-100">
                                Remember me
                            </label>
                        </div>

                        <div class="text-sm">
                            <a href="#" class="font-medium text-blue-400 hover:text-blue-500">
                                Forgot your password?
                            </a>
                        </div>
                    </div>

                    <div>
                        <loading-button :loading="sending" class="w-full flex justify-center py-4 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" type="submit">Login</loading-button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'

export default {
    metaInfo: { title: 'Login' },
    components: {
        LoadingButton,
        Logo,
        TextInput,
    },
    props: {
        errors: Object,
    },
    data() {
        return {
            sending: false,
            form: {
                username: '',
                password: '',
                remember: null,
            },
        }
    },
    methods: {
        submit() {
            const data = {
                username: this.form.username,
                password: this.form.password,
                remember: this.form.remember,
            }

            this.$inertia.post(this.route('login.attempt'), data, {
                onStart: () => this.sending = true,
                onFinish: () => this.sending = false,
            })
        },
    },
}
</script>
